import { Market, SportMatchModel } from '@nf/types/odds';
import { OddsButton } from '@/components/widgets/odds-button';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { BetTypeContentProps } from '../bet-type-content';
import { betTypeService } from '@/services/bettype.service';
import { DisplayLineInfo, getDisplayLineInfo, getHomeTeamName, getTeamName } from '@/utils/odds-utils';
import { Box } from '@nf/utils-common/fpw/monadic';
import { stringEmptyCheck } from '@nf/utils-common/fpw/utils';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeCol32to1 = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();

	const t = useTranslations('General');
	const choiceT = useTranslations('Choice');

	const { user } = useAccountInfo();
	const oddsData = useAtomValue(oddsPageAtom);

	const betTypeId = betTypeArray[0].BetTypeId;
	const setting = getBetTypeSetting(betTypeId, matchModel.GameID);
	const { betChoices, betTypesCategory } = setting;
	const sortedBetTypeArray = betTypeArray.sort((a, b) => a.Line - b.Line);

	const getBetChoiceName = (market: Market, betTypeId: number, betTeam: string, label: string) => {
		if (matchModel?.GameID === 50 && betTypesCategory) {
			return betTypeService.getBetChoiceDisplaySettingLabelByCricket(betTypeId, market, betTeam, label);
		} else {
			switch (setting?.betChoiceTranslateType) {
				case 'General':
					let choiceName;

					const choiceCombineHaOuBetType = [646, 3913, 8825];
					if (choiceCombineHaOuBetType.includes(betTypeId)) {

						const isHome = ['ho', 'hu'].includes(betTeam);
						const teamName = isHome
							? getHomeTeamName(matchModel?.TeamId1, matchModel.Neu, t('Neutral_Team'), oddsData?.teamNameMap)
							: getTeamName(matchModel?.TeamId2, oddsData?.teamNameMap);

						switch (betTypeId) {
							case 646: // basketball > Match Handicap & Total
								const getTranslatedLine = ({ prefixLabel, displayLine }: DisplayLineInfo) => stringEmptyCheck(prefixLabel)
									.fold(
										() => displayLine,
										(label: string) => `${t(label)}${displayLine}`
									);

								const line = Box.of({
									line: market.hdp2 ?? 0,
									betType: betTypeId,
									betTeam: isHome ? 'h' : 'a'
								})
									.map(getDisplayLineInfo)
									.map(getTranslatedLine)
									.extract();

								choiceName = t(label, { 0: teamName, 1: line, 2: market.Line });
								break;
							case 8825:	
							case 3913: 
								choiceName = t(label, { 0: teamName, 1: market.Line });
								break;
						}
					} else {
						choiceName = t(label);
					}
					return choiceName;
				case 'Choice':
					return choiceT.raw(label);
			}
			return label;
		}
	}

	return (
		<div className="bettype__content bettype__content--col-3-2to1">
			{
				sortedBetTypeArray.map(market =>
					betChoices.map(choice => {
						// Odds資料會全給，但這裡Esport會有不同的Map
						if (matchModel.GameID == 43 && market.BetTypeId == 9088) {
							if (!matchModel.BOF || choice.bof != matchModel.BOF) {
								return null;
							}
						}
						const choiceDisplayName = getBetChoiceName(market, market.BetTypeId, choice.betTeam, choice.label);
						return (
							choiceDisplayName ? (
								<div key={choice.betTeam} className="bettype__list">
									<div className="bettype__title bettype__title--left" dangerouslySetInnerHTML={{ __html: choiceDisplayName }} />
									<OddsButton
										key={`${market.Line}_${choice.betTeam}`}
										match={matchModel as SportMatchModel}
										market={market}
										selection={market.Selections[choice.betTeam]}
										homeTeamName={''}
										awayTeamName={''}
										variant="default"
										betTeam={market.Selections[choice.betTeam].SelId}
										originalPrice={market.Selections[choice.betTeam].Price}
										sport={matchModel?.GameID}
										type="OU"
										oddsType={user?.OType}
										accountStatus={user?.ActStatus ?? 0}
									/>
								</div>
							) : null
						)
					})
				)
			}
		</div>
	)
};
